export default __webpack_public_path__ + "static/media/ce.4f05bb00.png";